export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB1tf5ESItC3hf0HMdMj1bEKAmTLU0vsKo",
    authDomain: "rentmu-cms.firebaseapp.com",
    projectId: "rentmu-cms",
    storageBucket: "rentmu-cms.firebasestorage.app",
    messagingSenderId: "937829763947",
    appId: "1:937829763947:web:88a4b9ceb02dc2024eda2e",
    measurementId: "G-M7L4RWWQLB"
  }
};
